import { Dialog, DialogContent, DialogTitle, FormHelperText, Grid, TextField, Tooltip } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import setToast from '../../helpers/toaster.helper';
import { OrganizationModel } from '../../models/organization.model';
import { PhoneNumberModel, ProviderModel } from '../../models/phone-number.model';
import { PhoneNumberService } from '../../services/PhonenumberService';
import { UtilityService } from '../../services/UtilityService';
import ButtonComponent from '../shared/button/button.component';
import { buttonLabels, ToasterTexts } from "../shared/constants";
import { validateForm } from '../shared/form-validation';
import { ToasterType } from '../shared/toaster/toaster.model';
import { CancelIcon } from '../../icon';
import { LoadPhoneNumbersGridData } from "../../actions/index";
import * as selector from "../../selectors/selectors";

interface Props {
    HandleClose: (value?: boolean) => void;
    SelectedPhoneNumberId: string,
    EditPhoneNumber: boolean;
    ProviderData: ProviderModel[];
    OrganizationData: OrganizationModel[];
}

const EditPhoneNumber = (props: Props) => {
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const [id, setId] = useState<string>("")
    const [name, setName] = useState<string>("")
    const [phoneNumber, setPhoneNumber] = useState<string>("")
    const [organizationID, setOrganizationID] = useState<string>("")
    const [providerID, setProviderID] = useState<number>(-1)
    const [getOrganizations, setGetOrganizations] = useState({})
    const [getProviders, setGetProviders] = useState({})
    const [showNotification, setShowNotification] = useState<boolean>(false)
    const [notificationText, setNotificationText] = useState<string>("")
    const [errors, setErrors] = useState<{
        Name: string,
        PhoneNumber: string,
        OrganizationID: string,
        ProviderID: string,
    }>({
        Name: "",
        PhoneNumber: "",
        OrganizationID: "",
        ProviderID: ""
    })
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        if (props.EditPhoneNumber && props.SelectedPhoneNumberId) {
            PhoneNumberService.getPhoneNumberById(props.SelectedPhoneNumberId).then(res => {
                delete res.data.errors;
                setId(res.data.id)
                setName(res.data.name)
                setPhoneNumber(res.data.number)
                setGetOrganizations(props.OrganizationData.find(x => x.ID === res.data.organizationId))
                setOrganizationID(res.data.organizationId)
                setGetProviders(props.ProviderData.find(x => x.ID === res.data.providerID))
                setProviderID(res.data.providerID)
            })


        }
    }, [])

    useEffect(() => {
        LoadPhoneNumbersGridData(dispatch);
    }, [])


    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
    };

    const phoneNumberMap = useMemo(() => {
        return new Map(PhoneNumbers?.map((x: PhoneNumberModel) => [x.ID, x]));
    }, [PhoneNumbers]);

    const formSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm({ Name: name, PhoneNumber: phoneNumber, ProviderID: providerID, OrganizationID: organizationID }, (Errors) => { setErrors({ ...errors, ...Errors }) })) {
            let PhoneNumber = phoneNumberMap.get(id);
            if (!!PhoneNumber) {
                setIsLoading(true)
                const data = {
                    id: PhoneNumber.ID,
                    name: name,
                    number: phoneNumber,
                    provider: providerID,
                    organizationId: organizationID
                }
                PhoneNumberService.updatePhoneNumber(data).then(res => {
                    setIsLoading(false)
                    props.HandleClose(true);
                    setToast(ToasterTexts.PHONENUMBER_EDIT_SUCCESS.replace('<Name>', data.name), ToasterType.SUCCESS)
                    LoadPhoneNumbersGridData(dispatch);
                }).catch((err) => {
                    setIsLoading(false)
                    setToast(err.response.data.message, ToasterType.DANGER)
                })
            }
        } else { }
    }

    const handleOrg = (e: any, values: any) => {

        if (!values) {
            setErrors({ ...errors, OrganizationID: "Organization cannot be blank" })
            setGetOrganizations(undefined)
        }
        else {
            setErrors({ ...errors, OrganizationID: "" })
            setGetOrganizations(values)
        }

    }
    const dialogOnExited = () => {
        setId("")
        setName("")
        setPhoneNumber("")
        setOrganizationID("")
        setProviderID(-1)
        setGetOrganizations({})
        setGetProviders({})
        setShowNotification(false)
        setNotificationText("")
        setIsLoading(false)
        setErrors({
            Name: "",
            PhoneNumber: "",
            OrganizationID: "",
            ProviderID: ""
        });

    }

    return (
        <>
            {!IsMobileDevice && props.EditPhoneNumber ?
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    // onExited={() => dialogOnExited()}
                    onClose={props.HandleClose}
                    aria-labelledby="customized-dialog-title"
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={props.EditPhoneNumber}
                    classes={{ paper: "br-2 dialogue-shadow" }}

                    disableEscapeKeyDown>
                    <DialogTitle className="dialog-header" id="customized-dialog-title">
                        <div className="h2-regular color-display-title d-flex" id="customized-dialog-title">
                            Edit Phone Number
                            <Tooltip title='Close' placement='bottom'>
                                <span className={"ml-auto"}>
                                    <CancelIcon className={"c-pointer"} onClick={() => props.HandleClose(false)} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className="o-x-hidden">
                        <form noValidate autoComplete="off" className="m-auto" onSubmit={formSubmit}>
                            <Grid container direction="row" spacing={2}>
                                <Grid item xs={12} md={6} lg={6} className="mt-1">
                                    <TextField autoFocus
                                        name="Name"
                                        placeholder="Name"
                                        label="Name"
                                        size="small"
                                        required
                                        fullWidth
                                        variant="outlined"
                                        value={name}
                                        onChange={(e) => { handleChange(e.target.name, e.target.value); setName(e.target.value) }
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}

                                    />
                                    <FormHelperText className=" h5-regular color-primary-danger t-align-right">
                                        {errors.Name}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6} className="mt-1">
                                    <TextField
                                        fullWidth
                                        label="Number"
                                        name="PhoneNumber"
                                        placeholder="Number"
                                        size="small"
                                        required
                                        variant="outlined"
                                        disabled={true}
                                        value={UtilityService.maskPhoneNumber(phoneNumber)}
                                        onChange={(e) => { handleChange(e.target.name, e.target.value); setPhoneNumber(e.target.value) }
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    />
                                    <FormHelperText className=" h5-regular color-primary-danger t-align-right">
                                        {errors.PhoneNumber}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6} className="mt-1">
                                    <Autocomplete
                                        size="small"
                                        options={props.OrganizationData.filter(x => x.Name !== null)}
                                        value={getOrganizations}
                                        getOptionLabel={(option) => option.Name}
                                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow', option: "custom-option" }}
                                        onChange={handleOrg}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"h4-regular color-menu-list-font-color p-1 d-flex justify-between w-p-100"}>
                                                {option.Name}
                                            </li>
                                        )}
                                        disabled={true}
                                        renderInput={(params) => <TextField {...params}
                                            label="Organization" name="OrganizationID" required variant="outlined" />}
                                    />
                                    <FormHelperText className=" h5-regular color-primary-danger t-align-right">
                                        {errors.OrganizationID}
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                            <div className={"d-flex float-right mt-2 mb-1"}>
                                <ButtonComponent Variant="secondary-btn-small" ClassName={"mr-1"} OnClick={() => props.HandleClose(false)} ButtonLabel={buttonLabels.CANCEL} />
                                <ButtonComponent Variant="primary-btn-small" ClassName={"px-4"} Type={"submit"} ButtonLabel={buttonLabels.SAVE} Loading={isLoading} />
                            </div>
                        </form>
                    </DialogContent>
                </Dialog> :
                <div className="box-shadow-display-background-shadow o-x-hidden w-fill h-v-100">
                    <div className={`${!IsMobileDevice && "t-align-center m-auto bg-color-secondary br-4 p-3"}`}>
                        {!IsMobileDevice && <><span className={"float-left h3"}>Add PhoneNumber</span>
                        </>}
                        <form noValidate autoComplete="off" className={"m-2"} onSubmit={formSubmit}>
                            <Grid container direction="row" spacing={3}>
                                <Grid item xs={12} md={6} sm={6} lg={6} className="mt-1">
                                    <TextField autoFocus
                                        name="Name"
                                        placeholder="Name"
                                        label="Name"
                                        size="small"
                                        required
                                        fullWidth
                                        variant="outlined"
                                        value={name}
                                        onChange={(e) => { handleChange(e.target.name, e.target.value); setName(e.target.value) }
                                        }
                                        InputProps={{ classes: { input: 'h2 color-text-field-font', } }}
                                    />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {errors.Name}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12} md={6} sm={6} lg={6} className="mt-1">
                                    <TextField
                                        fullWidth
                                        label="Number"
                                        name="PhoneNumber"
                                        placeholder="Number"
                                        size="small"
                                        required
                                        variant="outlined"
                                        value={UtilityService.maskPhoneNumber(phoneNumber)}
                                        disabled={true}
                                        onChange={(e) => { handleChange(e.target.name, e.target.value); setPhoneNumber(e.target.value) }
                                        }
                                        InputProps={{ classes: { input: 'h2 color-text-field-font', } }}
                                    />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {errors.PhoneNumber}
                                    </FormHelperText>
                                </Grid>

                                <Grid item xs={12} md={6} sm={6} lg={6} className="mt-1">
                                    <Autocomplete
                                        size="small"
                                        className={""}
                                        options={props.OrganizationData.filter(x => x.Name !== null)}
                                        value={getOrganizations}
                                        getOptionLabel={(option) => option.Name}
                                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        onChange={handleOrg}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"h2 color-primary-dark p-1 d-flex justify-between w-p-100"}>
                                                {option.Name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params}
                                            label="Organization" name="OrganizationID" required variant="outlined" />}
                                    />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {errors.OrganizationID}
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                            <div className={`px-1 p-relative btn-bottom-display`}>
                                <ButtonComponent Variant="primary-btn-small" ClassName={"w-p-100 justify-center mb-2 br-6"} Type={"submit"} ButtonLabel={props.EditPhoneNumber ? buttonLabels.SAVE : buttonLabels.SUBMIT} Loading={isLoading} />
                                {props.EditPhoneNumber && <ButtonComponent Variant="secondary-btn-small" OnClick={props.HandleClose} ButtonLabel={buttonLabels.CANCEL} ClassName={"w-p-100 justify-center mb-2 br-6"} />}
                            </div>
                        </form>

                    </div>
                </div>}
        </>
    )
}

export default EditPhoneNumber;